import { render, staticRenderFns } from "./CookieBannerConfiguration.vue?vue&type=template&id=5fc0bbc5&scoped=true"
import script from "./CookieBannerConfiguration.vue?vue&type=script&lang=ts"
export * from "./CookieBannerConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./CookieBannerConfiguration.vue?vue&type=style&index=0&id=5fc0bbc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0bbc5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VExpandTransition,VSelect,VTextField})
